import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  AdminFilterChipButton,
  AdminMainText,
  AdminMetadataText,
} from "../../../AdminDashboard/shared/adminUx";

const NotificationLayout = () => {
  const [unread, setUnread] = useState(false);
  const [all, setAll] = useState(true);

  const Data = [
    {
      reviewMessage:
        "Ensure seamless transactions and keep your business running smoothly with our straightforward billing section. Add/ remove payment methods, track and maintain record of all your pricing plans transactions with Trades Poster",
      serviceName: "trades poster 1",
      reviewDate: "1 hour ago",
      status: "Unread",
    },
    {
      reviewMessage:
        "Ensure seamless transactions and keep your business running smoothly with our straightforward billing section. your business running smoothly with our straightforward billing section.",
      serviceName: "trades poster 2",
      reviewDate: "1 hour ago",
      status: "Read",
    },
    {
      reviewMessage:
        "Ensure seamless transactions and keep your track and maintain record of all your pricing plans transactions with Trades Poster your business running smoothly with our straightforward billing section.",
      serviceName: "trades poster 3",
      reviewDate: "1 hour ago",
      status: "Unread",
    },
    {
      reviewMessage:
        "Ensure Add/ remove payment methods, track and maintain record of all your pricing plans transactions with Trades Poster your business running smoothly with our straightforward billing section.",
      serviceName: "trades poster 4",
      reviewDate: "1 hour ago",
      status: "Read",
    },
    {
      reviewMessage:
        "Ensure seamless transactions and keep your business running of all your pricing plans transactions with Trades Poster your business running smoothly with our straightforward billing section.",
      serviceName: "trades poster 5",
      reviewDate: "1 hour ago",
      status: "Read",
    },
  ];

  const UnreadData = Data.filter((item) => item.status === "Unread");

  return (
    <div className="lg:w-[600px] xl:w-[700px] 2xl:w-[800px] lg:mx-auto">
      <div className="flex items-center justify-start gap-3 mb-10">
        <AdminFilterChipButton
          type="button"
          className={all ? "!bg-pastalblue !text-primaryblue !border-pastalblue" : ""}
          onClick={() => {
            setAll(true);
            setUnread(false);
          }}
        >
          All
        </AdminFilterChipButton>
        <AdminFilterChipButton
          type="button"
          className={unread ? "!bg-pastalblue !text-primaryblue !border-pastalblue" : ""}
          onClick={() => {
            setAll(false);
            setUnread(true);
          }}
        >
          Unread
        </AdminFilterChipButton>
      </div>
      <div className="border-t border-t-mediumgray">
        {all && Data.map((item, index) => <NotificationRow data={item} key={index} />)}
        {unread && UnreadData.map((item, index) => <NotificationRow data={item} key={index} />)}
      </div>
    </div>
  );
};

export const NotificationRow = ({ data }) => {
  const isUnread = data.status === "Unread";
  return (
    <Link to="/customer-dashboard/dashboard">
      <div
        className={`cursor-pointer px-3 py-2 border-b border-b-mediumgray ${
          isUnread ? "bg-white lg:bg-pastalblue p-3" : ""
        }`}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-x-3">
            <img
              src={require("../../../../assets/img/default-image.jpg")}
              className="w-10 h-10 rounded-full object-cover flex-shrink-0"
              alt="profile"
            />
            <AdminMainText className="font-medium hover:text-primaryblue">
              {data.serviceName}
            </AdminMainText>
          </div>
          <AdminMetadataText className="text-offblack">{data.reviewDate}</AdminMetadataText>
        </div>
        <AdminMainText className="mt-2 text-offblack block">{data.reviewMessage}</AdminMainText>
      </div>
    </Link>
  );
};

export default NotificationLayout;
